module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/dapnet-logo.png"),
      "alt": "DAPNET Logo"
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar-main"
    }
  }, [(this.$store.getters.isUserLoggedIn) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/calls"
    }
  }, [_vm._v("Calls")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/callsigns"
    }
  }, [_vm._v("Callsigns")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("News")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rubrics"
    }
  }, [_vm._v("Rubrics")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters"
    }
  }, [_vm._v("All Transmitters")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters/map"
    }
  }, [_vm._v("Map")])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters/groups"
    }
  }, [_vm._v("Transmitter Groups")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/nodes"
    }
  }, [_vm._v("Nodes")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider-vertical"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(this.$store.getters.user.name) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [(this.$store.getters.isUserLoggedIn) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Edit User',
        params: {
          id: this.$store.getters.user.name
        }
      }
    }
  }, [_vm._v("Settings")])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.isUserLoggedIn) ? _c('div', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (!this.$store.getters.isUserLoggedIn) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.isUserLoggedIn) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_vm._v("Logout")])], 1) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-main"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_vm._v("Transmitters "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f7ff32c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Navigation.vue
// module id = 613
// module chunks = 1